// 用于兼容复词表的key, 处理CapCut转化
export const pluralLangMap = (lang: string) => {
  if (/zh-Hant-TW/i.test(lang)) {
    lang = 'zh';
  }
  return lang;
};
